export class LocaleViewModel {

    constructor(public name: string, public locale: string, public isSupported: boolean) {
    }

}
